import * as React from 'react';
import * as styles from "./EventList.css";
import { LocalizationService } from '../../../../services/LocalizationService';
import DateTimeService from '../../../../services/DateTimeService';
import { Helper } from '../../../../Helper';
import { IFontSlots } from '../../../../interfaces/IFontSlots';
import { IMessageCategory } from '../../../../interfaces/IMessage';
import { IAMessageCategories } from '../../../viewer/categories/MessageCategories';

export interface IProps {
  id?: string;
  image?: string;
  title?: string;
  content?: string;
  startDate?: Date;
  allDayEvent?: boolean;
  endDate?: Date;
  location?: string;
  borderRadius?: number;
  categories?: IMessageCategory[];
  showSkeleton?: boolean;
  highlightColor?: string;
  backgroundColor?: string;
  textColor?: string;
  dateBadgeBackgroundColor?: string;
  dateBadgeTextColor?: string
  borderColor?: string;
  dateBorderColor?: string;
  marginRight?: number;
  maxWidth?: number;
  width?: number;
  isMobile?: boolean;
  fontSlots?: IFontSlots;

  showDropShadow?: boolean;
  showTimespand?: boolean;
  showCategories?: boolean;
  showLocation?: boolean;

  select?: () => void;
}

export class IAEventList extends React.Component<IProps> {

  private readonly dateTimeService: DateTimeService = new DateTimeService();

  constructor(props: IProps) {
    super(props);
  }

  public render(): JSX.Element {
    let dateBadgeTextColor: string = this.props.dateBadgeBackgroundColor != undefined ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.dateBadgeBackgroundColor, "#ffffff", "#333333") : "#333333";
    dateBadgeTextColor = this.props.dateBadgeTextColor != undefined ? this.props.dateBadgeTextColor : dateBadgeTextColor;
    const isEventToday = this.props && this.props.startDate ? this.dateTimeService.isStartAndEndDateTheSameDay(this.props.startDate, new Date(), this.props.allDayEvent) : undefined;
    let isOneDayEvent = this.props.allDayEvent ? this.dateTimeService.getEventString(this.props.startDate, this.props.endDate, this.props.allDayEvent).length === 5 : this.props.endDate == undefined || this.props.endDate != undefined && this.dateTimeService.ConvertToDDMMYYYY(this.props.endDate) === this.dateTimeService.ConvertToDDMMYYYY(this.props.startDate);
    const showCategories = this.props.categories != undefined && this.props.categories.length > 0 && this.props.showCategories && this.props.categories.length > 0;
    let height = 75;
    if (this.props.showTimespand && this.props.showLocation && this.props.showCategories) {
      height = 95;
    }
    let enabledSections = 0;
    if (this.props.showTimespand) enabledSections++;
    if (this.props.showLocation) enabledSections++;
    if (this.props.showCategories) enabledSections++;
    return (
      <div
        className={styles.IA_eventList}
        style={{
          marginRight: this.props.marginRight,
          width: this.props.width ? this.props.width : 0,
          maxWidth: this.props.maxWidth,
          backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : "transparent",
          borderColor: this.props.borderColor ? this.props.borderColor : undefined,
          borderRadius: this.props.borderRadius,
          borderBottomLeftRadius: this.props.dateBorderColor ? `${this.props.borderRadius * 2}px` : this.props.borderRadius,
          borderTopLeftRadius: this.props.dateBorderColor ? `${this.props.borderRadius * 2}px` : this.props.borderRadius,
          boxShadow: this.props.backgroundColor != undefined && this.props.showDropShadow ? "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px" : "none",
          height: height
        }}
        onClick={() => !this.props.showSkeleton ? this.props.select() : {}}
      >
        {this.props.showSkeleton ?
          <div
            className={styles.IA_skeleton}
            style={{
              backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : "transparent"
            }}
          >
            <div className={styles.IA_skeletonImage} />
            <div className={styles.IA_skeletonHeadline} />
            <div className={styles.IA_skeletonHeadline2} />
            <div className={styles.IA_skeletonText} />
          </div>
          :
          <div>
            <div
              className={styles.IA_coverImage}
              style={{
                backgroundColor: this.props.dateBadgeBackgroundColor != undefined ? this.props.dateBadgeBackgroundColor : "#ffffff",
                color: dateBadgeTextColor,
                outline: this.props.dateBorderColor ? `1px solid ${this.props.dateBorderColor}` : "#eeeeee",
                boxShadow: !this.props.backgroundColor && this.props.showDropShadow ? "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px" : "none",
                borderTopLeftRadius: this.props.borderRadius ? this.props.borderRadius - 1 : 0,
                borderBottomLeftRadius: this.props.borderRadius ? this.props.borderRadius - 1 : 0,
                height: height - 2,
                fontFamily: this.props.fontSlots?.body?.fontFamily
              }}
            >
              {!isEventToday && !isOneDayEvent &&
                <div
                  className={styles.IA_coverOverlay}
                >
                  <div className={styles.IA_startDate}>{!this.props.allDayEvent ? `${this.dateTimeService.getDayInMonth(this.props.startDate)}. ${this.dateTimeService.getNameOfMonth(this.props.startDate, this.props.allDayEvent)?.substring(0, 3)?.toUpperCase()}` : `${this.dateTimeService.getEventString(this.props.startDate, this.props.endDate, this.props.allDayEvent).substring(0, 2)}. ${this.dateTimeService.getNameOfMonth(this.props.startDate, this.props.allDayEvent)?.substring(0, 3)?.toUpperCase()}`}</div>
                  <div
                    className={styles.IA_startDateendDateDivider}
                    style={{
                      backgroundColor: dateBadgeTextColor
                    }}
                  />
                  <div className={styles.IA_endDate}>{!this.props.allDayEvent ? `${this.dateTimeService.getDayInMonth(this.props.endDate)}. ${this.dateTimeService.getNameOfMonth(this.props.endDate, this.props.allDayEvent)?.substring(0, 3)?.toUpperCase()}` : `${this.dateTimeService.getEventString(this.props.startDate, this.props.endDate, this.props.allDayEvent).substring(8, 10)}. ${this.dateTimeService.getNameOfMonth(this.props.endDate, this.props.allDayEvent)?.substring(0, 3)?.toUpperCase()}`}</div>
                </div>
              }
              {isEventToday && !isOneDayEvent &&
                <div
                  className={styles.IA_coverOverlay}
                >
                  <div className={styles.IA_startDate}>{new LocalizationService().strings.DateTimeService_Today?.toUpperCase()}</div>
                  <div
                    className={styles.IA_startDateendDateDivider}
                    style={{
                      backgroundColor: dateBadgeTextColor
                    }}
                  />
                  <div className={styles.IA_endDate}>{!this.props.allDayEvent ? `${this.dateTimeService.getDayInMonth(this.props.endDate)}. ${this.dateTimeService.getNameOfMonth(this.props.endDate, this.props.allDayEvent)?.substring(0, 3)?.toUpperCase()}` : `${this.dateTimeService.getEventString(this.props.startDate, this.props.endDate, this.props.allDayEvent).substring(8, 10)}. ${this.dateTimeService.getNameOfMonth(this.props.endDate, this.props.allDayEvent)?.substring(0, 3)?.toUpperCase()}`}</div>
                </div>
              }
              {!isEventToday && isOneDayEvent &&
                <div
                  className={styles.IA_coverOverlay}
                >
                  <div className={styles.IA_coverOverlayMonth}>{this.dateTimeService.getNameOfMonth(this.props.startDate, this.props.allDayEvent)?.substring(0, 3)?.toUpperCase()}</div>
                  <div className={styles.IA_coverOverlayDay}>{!this.props.allDayEvent ? this.dateTimeService.getDayInMonth(this.props.startDate) : this.dateTimeService.getEventString(this.props.startDate, this.props.endDate, this.props.allDayEvent).substring(0, 2)}</div>
                </div>
              }
              {isEventToday && isOneDayEvent &&
                <div
                  className={styles.IA_coverOverlay}
                >
                  <div className={styles.IA_coverOverlayToday}>{new LocalizationService().strings.DateTimeService_Today?.toUpperCase()}</div>
                </div>
              }
            </div>
            {showCategories &&
              <IAMessageCategories
                categories={this.props.categories}
                paddingTop={5}
                paddingLeft={10}
                paddingRight={10}
                paddingBottom={3}
                showOverflowCounter
                disablePopup={this.props.isMobile}
                fontSlots={this.props.fontSlots}
                textColorWhenTransparentBackground={this.props.textColor}
              />
            }
            <div
              className={styles.IA_title}
              style={{
                paddingTop: this.props.showCategories && this.props.categories && this.props.categories.length > 0 ? 0 : (!this.props.showTimespand && !this.props.showCategories ? 10 : 5),
                color: this.props.textColor,
                lineClamp: enabledSections < 2 ? 2 : 1,
                WebkitLineClamp: enabledSections < 2 ? 2 : 1,
                fontFamily: this.props.fontSlots?.heading?.fontFamily
              }}
            >
              {this.props.title}
            </div>
            {this.props.showLocation && this.props.location &&
              <div style={{
                position: "absolute",
                paddingLeft: 13,
                bottom: this.props.showTimespand ? 22 : 6,
                left: 68,
                width: "100%",
                color: this.props.textColor,
                height: 20,
                fontFamily: this.props.fontSlots?.body?.fontFamily
              }}>
                <div className={styles.IA_locationLabel}>
                  {this.props.location}
                </div>
              </div>
            }
            {this.props.showTimespand &&
              <div
                className={styles.IA_timespand}
                style={{
                  color: this.props.textColor,
                  opacity: 0.5,
                  fontFamily: this.props.fontSlots?.body?.fontFamily
                }}
              >
                {this.dateTimeService.getEventString(this.props.startDate, this.props.endDate, this.props.allDayEvent, true)}
              </div>
            }
          </div>
        }

      </div>
    );
  }


}             